import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlankValueComponent, CustomCellComponent } from '@vendasta/galaxy/table';
import { ActivityInterface, FieldMaskInterface, FieldValueInterface } from '@vendasta/crm';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { firstValueFrom } from 'rxjs';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { ActivityService } from '../../../shared-services/crm-services/activity.service';
import { ActivityTaskStatus } from '../../../tokens-and-interfaces';
import { MatButtonModule } from '@angular/material/button';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { StandardIds, SystemFieldIds } from '../../../shared-services';

@Component({
  template: `
    <button mat-icon-button (click)="updateTaskCompletionStatus()">
      <mat-icon *ngIf="taskOpen; else taskComplete" class="open-task">radio_button_unchecked</mat-icon>
      <ng-template #taskComplete>
        <mat-icon class="completed-task">check_circle</mat-icon>
      </ng-template>
    </button>
  `,
  standalone: true,
  styleUrls: ['./task-status.component.scss'],
  imports: [CommonModule, BlankValueComponent, GalaxyPipesModule, TranslateModule, MatIconModule, MatButtonModule],
})
export class TaskStatusCellComponent extends CustomCellComponent {
  protected taskOpen = false;
  private activityId = '';
  private readonly activitySubtype = 'Task';
  private readonly analyticsService = inject(ProductAnalyticsService);
  set value(newValues: (FieldValueInterface | null)[]) {
    const statusField = newValues.filter(Boolean).find((field) => field?.fieldId === StandardIds.ActivityTaskStatus);
    this.taskOpen = statusField?.stringValue === ActivityTaskStatus.Open;
    const idField = newValues.filter(Boolean).find((field) => field?.fieldId === SystemFieldIds.ActivityID);
    this.activityId = idField?.stringValue || '';
  }
  updateTaskCompletionStatus() {
    const newStatus = this.taskOpen ? ActivityTaskStatus.Completed : ActivityTaskStatus.Open;
    const activity: ActivityInterface = {
      crmObjectId: this.activityId,
      crmObjectSubtype: this.activitySubtype,
      fields: [{ fieldId: StandardIds.ActivityTaskStatus, stringValue: newStatus }],
    };
    const mask: FieldMaskInterface = {
      paths: [StandardIds.ActivityTaskStatus],
    };
    try {
      firstValueFrom(this.activityService.updateActivity(activity, mask)).then(() => {
        this.snack.openSuccessSnack('TASK.STATUS_UPDATE.SUCCESS');
        this.taskOpen = !this.taskOpen;
      });
    } catch {
      this.snack.openErrorSnack('TASK.STATUS_UPDATE.ERROR');
    }

    this.analyticsService.trackEvent('task-table-update-status', 'sales-tasks', 'click', 1, {
      status: newStatus,
    });
  }

  constructor(private readonly activityService: ActivityService, private readonly snack: SnackbarService) {
    super();
  }
}
